import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import PatientForm from './PatientForm';
import PatientService from '../../services/patientService';

const EditPatient = () => {
  const navigate = useNavigate();
  const { patientId } = useParams();
  const auth = useAuth();
  const [patient, setPatient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPatient = async () => {
      if (!patientId || !auth.user?.access_token) {
        setError('ID de paciente no válido');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const patientData = await PatientService.getPatientById(patientId, auth.user.access_token);
        setPatient(patientData);
      } catch (error) {
        console.error('Error loading patient:', error);
        setError('Error al cargar el paciente');
      } finally {
        setIsLoading(false);
      }
    };

    loadPatient();
  }, [patientId, auth.user?.access_token]);

  const handleSuccess = () => {
    // Redirect to patient details after successful update
    navigate(`/patients/${patientId}`);
  };

  const handleCancel = () => {
    // Go back to patient details
    navigate(`/patients/${patientId}`);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/patients/list')}>
          Volver a Pacientes
        </button>
      </div>
    );
  }

  if (!patient) {
    return (
      <div className="error-container">
        <h2>Paciente no encontrado</h2>
        <p>El paciente solicitado no existe o ha sido eliminado.</p>
        <button onClick={() => navigate('/patients/list')}>
          Volver a Pacientes
        </button>
      </div>
    );
  }

  return (
    <PatientForm
      patient={patient}
      isModal={false}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};

export default EditPatient;
